import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

export function Component() {
  return (
    <>
      <BackgroundSection image="/welcome_image_step_2.png" />
      <Content>
        <Title variant="h1">Oops! Page Not Found</Title>

        <Text>
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Text>
      </Content>
    </>
  )
}

Component.displayName = 'NotFound'
